// Statische Stammdaten-Listen für die öffentlichen (nicht angemeldeten)
// Seiten (Passwort-Reset-Bestätigung, Einladung annehmen). Bewusst statisch
// gehalten, damit diese Seiten ohne gültige Session funktionieren und nicht
// auf authentifizierte Endpunkte (/gender, /academictitle, …) angewiesen sind.

export interface IPublicGender {
  idGender: number;
  Gender: string;
}

export interface IPublicAcademicTitle {
  idAcademicTitle: number;
  AcademicTitle: string;
}

export interface IPublicBusinessForm {
  idBusinessForm: number;
  BusinessForm: string;
  isLegalEntity: boolean;
}

export const genders: IPublicGender[] = [
  { idGender: 1, Gender: 'männlich' },
  { idGender: 2, Gender: 'weiblich' },
  { idGender: 3, Gender: 'divers' },
  { idGender: 4, Gender: 'keine Angabe' },
];

export const academicTitles: IPublicAcademicTitle[] = [
  { idAcademicTitle: 1, AcademicTitle: 'kein' },
  { idAcademicTitle: 2, AcademicTitle: 'Dr.' },
  { idAcademicTitle: 3, AcademicTitle: 'Prof.' },
  { idAcademicTitle: 4, AcademicTitle: 'Prof. Dr.' },
];

export const businessForms: IPublicBusinessForm[] = [
  { idBusinessForm: 1, BusinessForm: 'Privat', isLegalEntity: false },
  { idBusinessForm: 2, BusinessForm: 'Einzelunternehmen', isLegalEntity: false },
  {
    idBusinessForm: 3,
    BusinessForm: 'eingetragene Gesellschaft bürgerlichen Rechts (eGbR)',
    isLegalEntity: false,
  },
  {
    idBusinessForm: 4,
    BusinessForm: 'Eingetragener Kaufmann (e.K.)',
    isLegalEntity: false,
  },
  {
    idBusinessForm: 5,
    BusinessForm: 'Offene Handelsgesellschaft (OHG)',
    isLegalEntity: false,
  },
  {
    idBusinessForm: 6,
    BusinessForm: 'Kommanditgesellschaft (KG)',
    isLegalEntity: false,
  },
  {
    idBusinessForm: 7,
    BusinessForm: 'Unternehmergesellschaft (UG)',
    isLegalEntity: true,
  },
  {
    idBusinessForm: 8,
    BusinessForm: 'Gesellschaft mit beschränkter Haftung (GmbH)',
    isLegalEntity: true,
  },
  { idBusinessForm: 9, BusinessForm: 'Aktiengesellschaft (AG)', isLegalEntity: true },
  { idBusinessForm: 10, BusinessForm: 'GmbH & Co KG', isLegalEntity: true },
];
